import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class ThemeService {

  prefixTheme = '';
  currentTheme = 'industry';

  constructor() {}

  public setTheme(theme: string) {
    this.prefixTheme = this.currentTheme;
    this.currentTheme = theme;
  }

  private removeUnusedTheme(theme: string): void {
    document.documentElement.classList.remove(theme);
    const removedThemeStyle = document.getElementById(theme);
    if (removedThemeStyle) {
      document.head.removeChild(removedThemeStyle);
    }
  }

  private loadCss(href: string, id: string): Promise<Event> {
    return new Promise((resolve, reject) => {
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = href;
      style.id = id;
      style.onload = resolve;
      style.onerror = reject;
      document.head.append(style);
    });
  }

  public loadTheme(firstLoad = true): Promise<Event> {
    const theme = this.currentTheme;
    if (firstLoad) {
      document.documentElement.classList.add(theme);
    }
    return new Promise<Event>((resolve, reject) => {
      this.loadCss(`${theme}.css`, theme).then(
        (e) => {
          if (!firstLoad) {
            document.documentElement.classList.add(theme);
          }
          this.prefixTheme && this.prefixTheme !== this.currentTheme && this.removeUnusedTheme(this.prefixTheme);
          resolve(e);
        },
        (e) => reject(e)
      );
    });
  }
}
